import React, { useState, useCallback, useRef } from "react";
import moment from "moment";
import { BASE_URL } from "constants/routes";
import { useSelector } from "react-redux";

const VideoViewer = (props) => {
  const {
    input_fields,
    label: document_label,
    selectedData,
    name: document_name,
    isMapper,
    documentData,
    form_field_items,
    recursive_section,
    recursive_Data,
    
  } = props;
  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  let videoSrc = "";
  let videoObject = {};
  let videoUrl = "";
  let downloadUrl = "";
  let isPdf = false;
  const label = isMapper ? documentData?.field_label : document_label;
  let name = isMapper ? documentData?.field_label : document_name;
  const applicationStatus = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.status
  );
  let videoEle = document.getElementById("livenessVideo");
  let playBtn = document.querySelector(".btn-play");

  if (name) {
    if (isMapper) {
      videoObject = documentData || {};
    } else if (recursive_section) {
      videoObject = recursive_Data[name];
    } else {
      videoObject = selectedData?.documents && selectedData?.documents[name];
    }

    if (
      videoObject?.encrypted_filename &&
      currentSubWorkFlowId &&
      !recursive_section
    ) {
      videoUrl = `${BASE_URL}/workflow/viewUploadedDocument/${currentSubWorkFlowId}/${name}/${
        videoObject?.encrypted_filename
      }${isMapper ? `/${form_field_items}` : ""}`;
    }
  }
  const getTime = useCallback((milliseconds) => {
    let m = moment.utc(milliseconds);
    let mins = m.minutes();
    let secs = m.seconds();
    return `${mins < 10 ? `0${mins}` : mins} : ${
      secs < 10 ? `0${secs}` : secs
    }`;
  }, []);

  const handlePlayVideo = (newTime) => {
    const seconds = newTime / 1000;
    setCurrentTime(seconds);
  };

  const playVideo = () => {
    videoEle.play();
    playBtn.classList.add("d-none");
  };

  const pauseVideo = () => {
    videoEle.pause();
    playBtn.classList.remove("d-none");
  };

  return (
    <div className="col-lg-6 col-md-12 col-sm-12">
      <div className="d-flex align-items-center position-relative video-cover">
        <video
          onClick={() => {
            pauseVideo();
          }}
          ref={videoRef}
          onPlay={() => {
            videoRef.current.currentTime = currentTime;
          }}
          className="liveness-video w-100 rounded-3 bg-dark"
          style={{
            height: "200px",
          }}
          src={videoUrl}
          // controls
          autoPlay={false}
          seekable="true"
          // preload="none"
          muted={true}
          id="livenessVideo"
        >
          Sorry, your browser doesn't support embedded videos, but don't worry,
          you can
          <a href="https://archive.org/details/BigBuckBunny_124">download it</a>
          and watch it with your favorite video player!
        </video>
        <div className="d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle">
          <div
            className="border border-white border-4 rounded-circle w-35px h-35px d-flex align-items-center justify-content-center btn-play"
            onClick={() => playVideo()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9.796"
              height="13.271"
              viewBox="0 0 9.796 13.271"
              className="ms-1"
            >
              <path
                id="play-button_1_"
                data-name="play-button (1)"
                d="M15.159,6.375,6,.056a.316.316,0,0,0-.5.26v12.64a.316.316,0,0,0,.5.26L15.159,6.9a.316.316,0,0,0,0-.52Z"
                transform="translate(-5.5)"
                fill="#fff"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoViewer;
